import { assign } from 'xstate';

import {
  Context,
  ToggleSubscriptionDetailsVisibilityEvent,
  SetListExpandedStateEvent,
  UpdateSubscription,
} from './types';

export const updateSubscription = assign({
  items: (context: Context, event: UpdateSubscription) => {
    const {
      catalogId,
      subscriptionId,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      type,
      ...subscriptionDetails
    } = event;
    const subscriptions = context.items[catalogId].map((item) => {
      if (item.subscription.id === subscriptionId) {
        return {
          ...item,
          subscription: {
            ...item.subscription,
            ...subscriptionDetails,
          },
        };
      }
      return item;
    });
    return {
      ...context.items,
      [catalogId]: subscriptions,
    };
  },
});

export const toggleSubscriptionDetailsVisibility = assign({
  itemsWithVisibleDetails: (
    context: Context,
    event: ToggleSubscriptionDetailsVisibilityEvent
  ) => {
    const { subscriptionId } = event;
    const detailsVisible =
      context.itemsWithVisibleDetails.includes(subscriptionId);
    return !detailsVisible
      ? [...context.itemsWithVisibleDetails, subscriptionId]
      : context.itemsWithVisibleDetails.filter((id) => id !== subscriptionId);
  },
});

export const setListExpandedState = assign({
  catalogs: (context: Context, event: SetListExpandedStateEvent) => {
    const { catalogId, status } = event;
    return {
      ...context.catalogs,
      [catalogId]: {
        ...context.catalogs[catalogId],
        isListExpanded: status,
      },
    };
  },
});
